
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class"; 

import CreditorOrgSurvey from './CreditorOrgSurvey.vue';
 
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType } from "@/types/Application";
import { creditorOrgInfoType } from '@/types/Application/Creditor';

@Component({
    components:{
      CreditorOrgSurvey
    }
})
export default class CreditorOrgInfo extends Vue {   

    @Prop({required: true})
    step!: stepInfoType;
    
    @Prop({required: true})
    creditorOrgData!: creditorOrgInfoType[];   

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.State
    public deceasedName!: string;   
    
    showOrgTable = true;
    anyOrgRowToBeEdited = null; 
    editOrgId = null;
    incompleteOrgError =  false; 
    updatedOrg = 0;

    creditorOrgList: creditorOrgInfoType[] = [];
    
    mounted(){
        this.updatedOrg = 0;
        this.creditorOrgList = JSON.parse(JSON.stringify(this.creditorOrgData));
        Vue.nextTick(()=>this.surveyHasError());
    }    
    

    public openOrgForm(anyRowToBeEdited?) {
        this.showOrgTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('creditor-org-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editOrgId = anyRowToBeEdited.id;
            this.anyOrgRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyOrgRowToBeEdited = null;
        }
    }

    public creditorOrgComponentData(value) {       
        this.showOrgTable = value;
    }

    public populateOrgSurveyData(creditorValue) {

        const currentIndexValue = this.creditorOrgList?.length > 0 ? this.creditorOrgList[this.creditorOrgList.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCreditor = { ...creditorValue, id };
        this.creditorOrgList = [...this.creditorOrgList, newCreditor];
        this.updatedOrg++;
        
        this.$emit("creditorChange",this.creditorOrgList);
        this.showOrgTable = true; 
       
    }   

    public deleteOrgRow(rowToBeDeleted) {
       
       this.creditorOrgList = this.creditorOrgList.filter(data => {
           return data.id !== rowToBeDeleted;
       }); 
       this.updatedOrg++;
      this.$emit("creditorChange",this.creditorOrgList);
       this.surveyHasError();
    }

    public editOrgRow(editedRow) {
        this.creditorOrgList = this.creditorOrgList.map(data => {
            return data.id === this.editOrgId ? editedRow : data;
        });
        this.updatedOrg++;
        this.$emit("creditorChange",this.creditorOrgList);
        this.showOrgTable = true;
        this.surveyHasError();
    }  

    public surveyHasError(){       

        this.incompleteOrgError =  false;        
        for(const creditor of this.creditorOrgList){
            if (!creditor.creditorOrganizationName){            
                this.incompleteOrgError = true;
                break
            }
        }        
        
    } 
    
}
